import { enumWidgetType } from "./widgetTypes";

export const NativeResourceCenterWidget = {
  type: enumWidgetType.nativeResourceCenter,

  // eslint-disable-next-line no-unused-vars
  Load(widgetConfig, context) {
    return true;
  },

  Activate({ wsMgr }) {
    wsMgr.BroadcastTopic("nativeResourceCenter:open", {});
    const eventTracker = wsMgr.GetUsageTracker();
    eventTracker?.ReportEvent("resource_center.help_menu.opened");
  }
};
